var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[(_vm.showNavigationMenu())?_c('TopHeader'):_vm._e(),(_vm.showNavigationMenu())?_c('NavigationDrawer'):_vm._e(),_c('Loader'),_c('snack-bar'),_c('router-view'),_c('v-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }